var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13447_3654",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H12V12.5H0V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13447_3654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50681 7.68762C8.02157 7.68762 9.36003 8.0452 10.4474 8.51269C11.4512 8.95263 12.0832 9.94242 12.0832 11.0152V12.5H0.93042V11.0244C0.93042 9.94242 1.56271 8.95263 2.56624 8.52188C3.65358 8.0452 4.99204 7.68762 6.50681 7.68762ZM6.50681 1.5C6.8731 1.49948 7.2359 1.57025 7.57442 1.70825C7.91294 1.84625 8.22052 2.04878 8.47954 2.30423C8.73857 2.55967 8.94394 2.86302 9.0839 3.19689C9.22386 3.53075 9.29565 3.88857 9.29516 4.24985C9.29569 4.61115 9.22393 4.96901 9.08399 5.30291C8.94405 5.63681 8.73868 5.94019 8.47965 6.19567C8.22062 6.45115 7.91303 6.6537 7.57449 6.79173C7.23595 6.92975 6.87313 7.00053 6.50681 7C6.14051 7.00049 5.77772 6.92968 5.43922 6.79164C5.10072 6.6536 4.79316 6.45104 4.53416 6.19556C4.27517 5.94008 4.06983 5.63672 3.92991 5.30284C3.78999 4.96896 3.71824 4.61113 3.71877 4.24985C3.71828 3.8886 3.79006 3.5308 3.93 3.19696C4.06994 2.86311 4.27528 2.55978 4.53427 2.30434C4.79326 2.04889 5.10081 1.84636 5.43929 1.70834C5.77777 1.57032 6.14054 1.49952 6.50681 1.5Z",
    fill: "#ADB5BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserButton);
export default __webpack_public_path__ + "static/media/user_button.6077bba5b8e94af542f30e2e6235782f.svg";
export { ForwardRef as ReactComponent };